import React from 'react'
import { Spinner } from 'react-bootstrap'

function Loader() {
  return (
    <div className='d-flex justify-content-center p-5'>
      <Spinner animation="border" style={{width: '5em', height: '5em'}} />
    </div>
  )
}

export default Loader
